import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("almox_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const tenantLogoUrl = (tenantId) => tenantId ? `${API}/branding/${tenantId}/logo` : null;

export const fileUrl = (path) => {
  if (!path) return null;
  if (path.startsWith("http")) return path;
  const clean = path.replace(/^\/+/, "").replace(/^api\//, "").replace(/^files\//, "");
  return `${API}/files/${clean}`;
};

export function apiErr(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Erro inesperado";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(d);
}

export default api;
